<h4 mat-dialog-title>
    Order Info Email
</h4>

<mat-dialog-content>
    <div class="col-lg-12">
        <employee-popup (employeesChanged)="employeeSelected($event)"
                        (groupIdChanged)="groupSelected($event)"
                        (emailsChanged)="emailsSelected($event)"
                        [extraEmails]="data.extraEmails"
                        [initGroups]="data.groups"
                        [initEmployees]="data.employees"></employee-popup>
    </div>

    <div class="col-lg-12" *ngIf="data != null && data.showNotes != null && data.showNotes">
        <label style="display: block;">Notes</label>
        <textarea rows="5" cols="75" [(ngModel)]="notes"></textarea>
    </div>

    <div class="col-lg-12" *ngIf="data != null && data.showCheckCallNotes != null && data.showCheckCallNotes">
        <label style="display: block;">Check Call Notes</label>
        <textarea rows="5" cols="75" [(ngModel)]="checkCallNotes"></textarea>
    </div>

    <div class="col-lg-12" *ngIf="data != null && data.showSystemNotes != null && data.showSystemNotes">
        <label style="display: block;">System Notes</label>
        <textarea rows="5" cols="75" [(ngModel)]="systemNotes" disabled></textarea>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="btn btn-primary" (click)="select()">Send Email</button>
    <button class="btn btn-secondary" (click)="cancel()" *ngIf="isShowCancel">Cancel</button>
</mat-dialog-actions>
